import { render, staticRenderFns } from "./basicInfo.vue?vue&type=template&id=4fb1d397&scoped=true&"
import script from "./basicInfo.vue?vue&type=script&lang=js&"
export * from "./basicInfo.vue?vue&type=script&lang=js&"
import style0 from "./basicInfo.vue?vue&type=style&index=0&id=4fb1d397&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb1d397",
  null
  
)

export default component.exports